import React, { useState } from 'react'
import './digital-vault-reports.css'
import { Container, Grid } from '@material-ui/core'
import { DigitalVaultDocumentAction, DigitalVaultOperationalReportAction, DigitalVaultStatisticalReportAction } from '../../actions'
import { DropDownBtnHLPure, SimpleLoading } from '../../pures'

const DigitalVaultReportsView = (props) => {
    const {
        isLoading,
        isUser,
        companies,
        selectedCompanyId,
        setSelectedCompanyId,

        selectedDocumentId,
        setSelectedDocumentId,

        toggleCompletedRequesting,
        toggleLoadingRequesting,
        toggleErrorRequesting
    } = props;

    const [viewOperationalReport, setViewOperationalReport] = useState(true);
    const onReportTypeChange = (e) => setViewOperationalReport(e.target.value === 'operacional');

    const onCompanyDropdownChange = (e) => setSelectedCompanyId(e.target.value)

    if (isLoading) return <SimpleLoading />

    if (selectedDocumentId) return <DigitalVaultDocumentAction
        stateToMaintain={{ selectedCompanyId }}
        documentId={selectedDocumentId}
        goBack={() => setSelectedDocumentId(null)}
    />

    return (
        <Container disableGutters className='digitalVaultReportsView'>
            <Grid container spacing={3}>
                <div className='digitalVaultReportsView-filter-btns'>
                    <DropDownBtnHLPure
                        optionsDropDown={companies}
                        optionsValue={selectedCompanyId}
                        valueItem={'id'}
                        nameOption={'companyName'}
                        onDropDownChange={onCompanyDropdownChange}
                        iconFilter={true}
                    />
                    {
                        !isUser &&
                        <Grid item role='radiogroup' aria-label='Tipo de reporte' className='digitalVaultView-viewType'>
                            <label className='digitalVaultView-viewType-option' aria-label='Reporte operacional'>
                                <input type='radio' name='view' value='operacional' checked={viewOperationalReport} onChange={onReportTypeChange} />
                                <span className='digitalVaultView-viewType-img'>
                                    <img aria-hidden='true' src='https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Table view.svg' />
                                </span>
                            </label>
                            <label className='digitalVaultView-viewType-option' aria-label='Reporte estadístico'>
                                <input type='radio' name='view' value='estadistico' checked={!viewOperationalReport} onChange={onReportTypeChange} />
                                <span className='digitalVaultView-viewType-img listview'>
                                    <img aria-hidden='true' src='https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/StatisticsView.svg' />
                                </span>
                            </label>
                        </Grid>
                    }
                </div>
                <Grid item xs={12}>
                    {
                        viewOperationalReport
                            ? <DigitalVaultOperationalReportAction
                                isUser={isUser}
                                selectedCompanyId={selectedCompanyId}
                                setSelectedDocumentId={setSelectedDocumentId}
                                toggleCompletedRequesting={toggleCompletedRequesting}
                                toggleLoadingRequesting={toggleLoadingRequesting}
                                toggleErrorRequesting={toggleErrorRequesting}
                            />
                            : <DigitalVaultStatisticalReportAction
                                selectedCompanyId={selectedCompanyId}
                                setSelectedDocumentId={setSelectedDocumentId}
                                toggleCompletedRequesting={toggleCompletedRequesting}
                                toggleLoadingRequesting={toggleLoadingRequesting}
                                toggleErrorRequesting={toggleErrorRequesting}
                            />
                    }
                </Grid>
            </Grid>
        </Container>
    )
}

export default DigitalVaultReportsView